/*
 * @Author: cc
 * @Date: 2020-04-05 16:34:53
 * @LastEditTime: 2020-05-05 13:38:46
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\website\toBeCompiled\websitetoBeCompiledRouter.js
 * @Description: 
 */
'use strict';
angular.module('websitetoBeCompiledRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.editctr.website.waitcompiled', {
            url: '/waitcompiled?siteid&channelid&mediatype',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/website/toBeCompiled/main_tpl.html',
                    controller: 'websitetoBeCompiledCtrl'
                }
            }
        }).state('front.editctr.website.waitcompiled.cloud', {
            url: '/cloud',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/website/cloud/cloud_tpl.html',
                    controller: 'websiteMlfCloudCtrl'
                }
            }
        }).state('front.editctr.website.waitcompiled.timingSign', {
            url: '/timingSign',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/website/toBeCompiled/timingSign/timingSign_tpl.html',
                    controller: 'editCompileWebsiteTimingSignController'
                }
            }
        }).state('front.editctr.website.waitcompiled.recycle', {
            url: '/recycle',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/website/toBeCompiled/recycle/main_draft_tpl.html',
                    controller: 'editCompileWebsiteRecycleController'
                }
            }
        }).state('front.editctr.website.waitcompiled.myshare', {
            url: '/myshare',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/myManuscript/myShare/myShare_tpl.html',
                    controller: 'myShareCtrl'
                }
            }
        }).state('websitenews', {
            url: '/websitenews?wzchannelid&wzchnldocid&wzmetadataid&wzsiteid&wzplatform&isawaitrevise',
            views: {
                '': {
                    templateUrl: './editingCenter/website/toBeCompiled/news/website_toBeCompiled_news.html',
                    controller: 'editingCenterWebsiteNewsCtrl'
                }
            }
        }).state('websiteatlas', {
            url: '/websiteatlas?wzchannelid&wzchnldocid&wzmetadataid&wzsiteid&wzplatform&isawaitrevise',
            views: {
                '': {
                    templateUrl: './editingCenter/website/toBeCompiled/atlas/atlas_tpl.html',
                    controller: 'editingCenterWebsiteAtlasCtrl'
                }
            }
        }).state('websitelinkdoc', {
            url: '/websitelinkdoc?wzchannelid&wzchnldocid&wzmetadataid&wzsiteid&wzplatform&isawaitrevise',
            views: {
                '': {
                    templateUrl: './editingCenter/website/toBeCompiled/linkDoc/linkDoc_tpl.html',
                    controller: 'editingCenterWebsiteLinkDocCtrl'
                }
            }
        }).state('websitesubject', {
            url: '/websitesubject?wzchannelid&wzchnldocid&wzmetadataid&wzsiteid&wzplatform&isawaitrevise',
            views: {
                '': {
                    templateUrl: './editingCenter/website/toBeCompiled/subject/subject_tpl.html',
                    controller: 'editingCenterWebsiteSubjectCtrl'
                }
            }
        }).state('websitevideo', {
            url: '/websitevideo?wzchannelid&wzchnldocid&wzmetadataid&wzsiteid&wzplatform&isawaitrevise',
            views: {
                '': {
                    templateUrl: './editingCenter/website/toBeCompiled/video/website_video_tpl.html',
                    controller: 'websiteVideoCtrl'
                }
            }
        }).state('websiteowner', {
            url: '/websiteowner',
            views: {
                '': {
                    templateUrl: './editingCenter/website/toBeCompiled/owner/owner_tpl.html',
                    controller: 'editingCenterWebsiteOwnerCtrl'
                }
            }
        });
    }]);
